import { render, staticRenderFns } from "./PosicaoNotaFiscalDetalhes.vue?vue&type=template&id=1c20cf6f"
import script from "./PosicaoNotaFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./PosicaoNotaFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports